import { createSlice } from "@reduxjs/toolkit";
import { loadAdvisorData } from "./userActions";

interface UserState {
  loading: boolean;
  userData: object | null;
  error: string | unknown;
  success: boolean;
}

const initialState: UserState = {
  loading: false,
  userData: null,
  error: null,
  success: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    userDataRequested: (state) => {
      state.loading = true;
    },
    userDataUpdated: (state, action) => {
      state.userData = action.payload;
    },
    userDataCleared: (state) => {
      state.loading = false;
      state.userData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadAdvisorData.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(loadAdvisorData.fulfilled, (state, action) => {
      state.loading = false;
      state.userData = action.payload;
    });
    builder.addCase(loadAdvisorData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { userDataRequested, userDataUpdated, userDataCleared } =
  userSlice.actions;

export default userSlice.reducer;
